import { render } from "./ResultsScreen.vue?vue&type=template&id=1dc01fee&scoped=true"
import script from "./ResultsScreen.vue?vue&type=script&lang=js"
export * from "./ResultsScreen.vue?vue&type=script&lang=js"

import "./ResultsScreen.vue?vue&type=style&index=0&id=1dc01fee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc01fee"]])

export default __exports__